import scrollTo from '../scrollTo';

export const getElementOffset = (el) => {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY,
  };
};

export const getInvalidFields = form => form.fields.reduce((acc, field) => {
  if (field.validateState === 'error') {
    acc.push(field);
  }
  return acc;
}, []);

export const scrollToErrorField = (form) => {
  const invalidFields = getInvalidFields(form);
  let hasHiddenField = false;

  invalidFields.forEach((field) => {
    const closestToggleLinkWrapper = field.$el.closest('.toggle-wrapper');

    if (closestToggleLinkWrapper && closestToggleLinkWrapper.classList.contains('is-hidden')) {
      const toggleLink = closestToggleLinkWrapper.querySelector('.toggle-link');
      if (toggleLink) {
        hasHiddenField = true;

        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        });

        toggleLink.dispatchEvent(clickEvent);
      }
    }
  });

  setTimeout(() => {
    const { top } = getElementOffset(invalidFields[0].$el);

    scrollTo({
      left: 0,
      top: top - 150,
    });
  }, hasHiddenField ? 100 : 1);
};
